import 'htmx.org';
import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

console.log("App initialized.");

/** * CRITICAL: DO NOT REMOVE OR MODIFY THE MARKERS BELOW.
 * The build.sh script uses these hooks to inject the Pow loader logic
 * from the pow-loader.template.js file during deployment.
 */
// --- POW LOADER START ---
/**
 * PoW Micro-Loader Component
 * Footprint: Minimalist (<550B gzipped). Pure detection and script loading.
 */
(function () {
    const SCRIPT_ID = 'pow-solver-js';
    const SCRIPT_URL = '/pow-solver-v1.js'; // Patched by build.sh

    if (typeof WebAssembly === 'undefined') {
        console.warn('[PoW] WebAssembly unsupported. Protection bypassed.');
        window.powUnsupportedFallback = true;
        return;
    }

    function tryInjectSolver() {
        if (window.powInitFailedFallback) {
            document.querySelectorAll('form').forEach(form => {
                const btns = form.querySelectorAll('button[type="submit"], input[type="submit"]');
                btns.forEach(btn => {
                    btn.disabled = false;
                    btn.removeAttribute('disabled');
                    btn.classList.remove('loading');
                });
                const statusDiv = form.querySelector('.pow-status');
                if (statusDiv && !statusDiv.dataset.fallbackNotified) {
                    statusDiv.textContent = "Verification unavailable. Processing transaction safely...";
                    statusDiv.dataset.fallbackNotified = "true";
                }
            });
            return;
        }

        const forms = document.querySelectorAll('form');
        for (const form of forms) {
            const chal = form.querySelector('input[name="pow-challenge"]');
            const diff = form.querySelector('input[name="pow-difficulty"]');
            const sol = form.querySelector('input[name="pow-solution"]');

            if (chal && diff && sol && sol.value.trim() === '') {
                const d = parseInt(diff.value, 10);
                if (chal.value.trim() !== '' && !isNaN(d) && d >= 1 && d <= 32) {

                    // Lock submission instantly
                    const submitBtns = form.querySelectorAll('button[type="submit"], input[type="submit"]');
                    submitBtns.forEach(btn => {
                        btn.disabled = true;
                        btn.classList.add('loading');
                    });

                    if (!document.getElementById(SCRIPT_ID)) {
                        const s = document.createElement('script');
                        s.id = SCRIPT_ID;
                        s.src = SCRIPT_URL;
                        s.async = true;
                        s.onerror = () => {
                            console.error('[PoW] Failed to load solver script');
                            submitBtns.forEach(btn => {
                                btn.disabled = false;
                                btn.removeAttribute('disabled');
                                btn.classList.remove('loading');
                            });
                            window.powInitFailedFallback = true;
                        };
                        document.head.appendChild(s);
                    } else if (window.powSolverExecute) {
                        window.powSolverExecute();
                    }
                    return;
                }
            }
        }
    }

    let debounceTimer;
    const debouncedInject = () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => tryInjectSolver(), 100);
    };

    if (window.requestIdleCallback) {
        requestIdleCallback(() => tryInjectSolver(), { timeout: 2000 });
    } else {
        window.addEventListener('load', () => tryInjectSolver());
    }

    document.body.addEventListener('htmx:afterSwap', () => debouncedInject());
    document.body.addEventListener('htmx:afterSettle', () => debouncedInject());

    const observer = new MutationObserver(() => debouncedInject());
    observer.observe(document.body, { childList: true, subtree: true });

    window.powTriggerDetection = debouncedInject;
})();
// --- POW LOADER END ---
